<div class="col-xs-12  animated fadeIn">
    <div class="box no-padding">
        <div class="box-header">
            <h3 class="box-title">Listagem</h3>
        </div>

        <div class="box-body table-responsive no-padding" *ngIf="responderRoteiro.length != 0">
            <table class="table table-hover">
                <tbody>
                    <tr>
                        <th>Status</th>
                        <th>Situação</th>
                        <th>Resultado</th>
                        <th>Data submetido</th>
                        <th>Analisado por</th>
                        <th>Ação</th>
                    </tr>
                    <tr *ngFor="let item of responderRoteiro">
                        <td>
                            {{ verificaStatus(item.status) }}
                        </td>
                        <td>
                            <p *ngIf="item.situacao == 'ATIVO'">
                                ATIVO</p>
                            <p *ngIf="item.situacao == 'INATIVO'">
                                OBSOLETO</p>
                        </td>
                        <td>
                            <span *ngIf="item.statusControleInterno">
                                <p *ngIf="item.statusControleInterno == 'Aprovado'" class="label label-success">
                                    {{ item.statusControleInterno }}</p>
                                <p *ngIf="item.statusControleInterno == 'Reprovado'" class="label label-default">
                                    {{ item.statusControleInterno }}</p>
                                <p *ngIf="item.statusControleInterno == 'Ressalva'" class="label label-warning">
                                    Aprovado com ressalva</p>
                            </span>

                            <p *ngIf="!item.statusControleInterno"  class="label label-default">Aguardando</p>
                        </td>
                        <td>
                            <span *ngIf="item.data">{{ item.data  | date:'dd/MM/yyyy' }}</span>
                            <span *ngIf="!item.data"  class="label label-default">Aguardando</span>
                        </td>
                        <td>
                            <p *ngIf="!item.usuarioSubmeteu"  class="label label-default">Aguardando</p>
                            <p *ngIf="item.usuarioSubmeteu">{{item.usuarioSubmeteu.nome}}</p>
                        </td>
                        <td>
                            <span class="badge bg-blue cursor" *ngIf="item.status == 'Submetido'" pTooltip="Visualizar"
                                tooltipPosition="top" (click)="visualizarResponderRoteiro(item)">
                                <i class="fa fa-fw fa-eye"></i></span>
                            <span *ngIf="item.status == 'Em_elaboracao'" class="badge bg-blue cursor"
                                pTooltip="Emitir parecer" tooltipPosition="top" (click)="emitirParecer(item)"><i
                                    class="fa fa-fw fa-file-text-o"></i></span>
                            <span *ngIf="item.status == 'Submetido' && item.situacao == 'ATIVO'"
                                class="badge bg-blue cursor" pTooltip="Alterar parecer" tooltipPosition="top"
                                (click)="confirmaAlterarParecer(item)"><i class="far fa-edit"></i></span>
                            <!-- <span class="badge bg-red cursor" pTooltip="Eliminar parecer" tooltipPosition="top"
                                (click)="eliminarAnalise(item)"><i class="fa fa-fw fa-trash"></i></span> -->
                        </td>

                    </tr>

                </tbody>
            </table>
            <!-- <pagination [page]="page" (paginationEvent)=changePage($event)></pagination> -->
        </div>

        <div class="box-body table-responsive no-padding" *ngIf="responderRoteiro.length == 0">
            <h4 class="text-primary"> <b> &nbsp;&nbsp; Nenhum parecer encontrado</b></h4>
        </div>

    </div>
</div>